import { render, staticRenderFns } from "./BarExpensesChart.vue?vue&type=template&id=48865a90"
import script from "./BarExpensesChart.vue?vue&type=script&lang=js"
export * from "./BarExpensesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports